import { t } from "i18next";
import { ws } from "../../../utils/common";
import { isValidEmail } from "../../../utils/validation";

export const forgetPasswordWS = async ({ email }) => {
  if (!isValidEmail(email)) {
    throw { message: t("validation.email_not_valid") };
  }

  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "auth/forget-password",
    null,
    {
      email,
    },
    false
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
